import { render, staticRenderFns } from "./sh-set-driver-vehicleinfo-modal.vue?vue&type=template&id=06c2162c"
import script from "./sh-set-driver-vehicleinfo-modal.vue?vue&type=script&lang=js"
export * from "./sh-set-driver-vehicleinfo-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports